import styled from 'styled-components';
import MuiTableHead from '@mui/material/TableHead';

export const TableHead = styled(MuiTableHead)``;
